module.exports = __webpack_public_path__ + "static/media/edge.c962c4f0.svg";